import { render, staticRenderFns } from "./form_fixableday.vue?vue&type=template&id=063e35e8&scoped=true&"
import script from "./form_fixableday.vue?vue&type=script&lang=js&"
export * from "./form_fixableday.vue?vue&type=script&lang=js&"
import style0 from "./form_fixableday.vue?vue&type=style&index=0&id=063e35e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e35e8",
  null
  
)

export default component.exports